import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
import { TextTagTheme } from './TextTag';

const Tag = styled.span<{ tagTheme: TextTagTheme }>`
  ${fonts.helvetica['73-bold-extended']};
  display: inline-block;
  font-size: 14px;
  letter-spacing: ${fonts.ls(10)};
  line-height: 1.2;
  padding: 4px 8px;
  text-transform: uppercase !important;

  ${({ tagTheme }) => {
    switch (tagTheme) {
      case 'white':
        return css`
          background-color: ${brand.white};
          color: ${brand.red.base};
        `;

      case 'red':
      default:
        return css`
          background-color: ${brand.red.base};
          color: ${brand.white};
        `;
    }
  }}

  @media ${from(Device.Tablet)} {
    font-size: 16px;
  }
`;

export const TextTagStyles = {
  Tag,
};
